import React from 'react'
import { DropOffLocation } from '../../domain/models'
import { AdditionnalFilter } from '../hooks/useFilter'

export interface IDropOffLocationContext {
  dropOffLocationList: Array<DropOffLocation>
  setDropOffLocationList: (values: Array<DropOffLocation>) => void
  currentDropOffLocation?: DropOffLocation
  setCurrentDropOffLocation: (value: DropOffLocation | undefined) => void
  woosmapQuery?: string
  woosmapMapReady: boolean
  wasteTypeFilters: Array<string>
  setWasteTypeFilters: (wasteType: Array<string>) => void
  displaySubmitDropoffScreen: boolean
  setDisplaySubmitDropoffScreen: (shouldDisplay: boolean) => void
  displayGetRewardDropoffId: string | undefined
  setDisplayGetRewardDropoffId: (dropoffId: string | undefined) => void
  buildContextualQuery: (additionnalFilter: AdditionnalFilter) => string
  queryLoading: boolean
}

export const DropOffLocationContext = React.createContext<IDropOffLocationContext>({
  dropOffLocationList: [],
  woosmapMapReady: false,
  setDropOffLocationList: () => console.warn('setDropOffLocationList not implemented in the current context'),
  setCurrentDropOffLocation: () => console.warn('setCurrentDropOffLocation not implemented in the current context'),
  wasteTypeFilters: [],
  setWasteTypeFilters: () => console.warn('setWasteTypeFilters not implemented in the current context'),
  displaySubmitDropoffScreen: false,
  setDisplaySubmitDropoffScreen: () =>
    console.warn('setDisplaySubmitDropoffScreen not implemented in the current context'),
  displayGetRewardDropoffId: undefined,
  setDisplayGetRewardDropoffId: () =>
    console.warn('setDisplayGetRewardDropoffId not implemented in the current context'),
  buildContextualQuery: () => '',
  queryLoading: false
})

export const useDropOffLocationContext = (): IDropOffLocationContext => React.useContext(DropOffLocationContext)
